import React, { useRef, useState } from 'react';
import { Container, Grid, Button, Typography, Avatar } from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';
import { useLocation, useNavigate } from 'react-router-dom';
import { notifySuccess, notifyError } from '../Notification';
import { textCOC } from './textCOC';
import { submitCodeOfConduct } from '../api';
import ThankYouModal from '../layout/ThankyouModal';
const CodeOfConduct = ({ onSubmit }) => {
  const [isModalVisible, setModalVisible] = useState(false);
    const closeModal = () => {
        setModalVisible(false);  
      };
  const location = useLocation();
  const navigate = useNavigate();
  const child = location.state?.child;
  console.log("Child Data:", child);
  const [parentSignature, setParentSignature] = useState(null);
  const [studentSignature, setStudentSignature] = useState(null);

  const parentSignatureRef = useRef({});
  const studentSignatureRef = useRef({});

  const handleClearSignature = (ref, setSignature) => {
    ref.current.clear();
    setSignature(null);
  };

  const handleSaveSignature = (ref, setSignature) => {
    const dataUrl = ref.current.toDataURL('image/png');
    setSignature(dataUrl);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('student_id', child.id);
    if (parentSignature) {
      const response = await fetch(parentSignature);
      const blob = await response.blob();
      formData.append('parentSignatureFile', blob, 'parentSignature.png');
    }
    if (studentSignature) {
      const response = await fetch(studentSignature);
      const blob = await response.blob();
      formData.append('studentSignatureFile', blob, 'studentSignature.png');
    }

    try {

      await submitCodeOfConduct(formData);
      notifySuccess("Form submitted successfully!");
      setModalVisible(true);
    } catch (error) {
      notifyError("Form submitted successfully!");
      // Error handling is already done in the API function
    }

  };

  return (
    <Container sx={{ pt: 4, backgroundColor: 'white', borderRadius: '8px', width: '100%', maxWidth: '800px', margin: '0px auto', marginBottom: '20px' }}>
      {textCOC()}

      <Typography variant="body1" paragraph>
        By signing this Code of Conduct, students and parents acknowledge their understanding and acceptance of the school's expectations and the consequences of misconduct. Together, we can create a positive and respectful school environment.
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2} alignItems="center" mt="15px" mb="10px">
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" align="center">Parent Signature</Typography>
            {parentSignature && (
              <Avatar src={parentSignature} variant="square" sx={{ width: 200, height: 150, mb: 2 }} />
            )}
            <SignatureCanvas
              penColor="black"
              ref={parentSignatureRef}
              canvasProps={{ width: 300, height: 150, className: 'sigCanvas' }}
            />
            <Grid container spacing={1} justifyContent="center" mt={1}>
              <Grid item>
                <Button
                  variant="contained"
                  
                  size="small"
                  sx={{ boxShadow: 3 }}
                  onClick={() => handleSaveSignature(parentSignatureRef, setParentSignature)}
                >
                  Save Signature
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  sx={{ boxShadow: 3 }}
                  onClick={() => handleClearSignature(parentSignatureRef, setParentSignature)}
                >
                  Clear Signature
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" align="center">Student's Signature</Typography>
            {studentSignature && (
              <Avatar src={studentSignature} variant="square" sx={{ width: 200, height: 150, mb: 2 }} />
            )}
            <SignatureCanvas
              penColor="black"
              ref={studentSignatureRef}
              canvasProps={{ width: 300, height: 150, className: 'sigCanvas' }}
            />
            <Grid container spacing={1} justifyContent="center" mt={1}>
              <Grid item>
                <Button
                  variant="contained"
                  
                  size="small"
                  sx={{ boxShadow: 3 }}
                  onClick={() => handleSaveSignature(studentSignatureRef, setStudentSignature)}
                >
                  Save Signature
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  sx={{ boxShadow: 3 }}
                  onClick={() => handleClearSignature(studentSignatureRef, setStudentSignature)}
                >
                  Clear Signature
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: 'center', mt: 2 }}>
            <Button type="submit" variant="contained" color="primary" sx={{ boxShadow: 3 }}>
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
      <ThankYouModal isVisible={isModalVisible} onClose={closeModal} />
    </Container>
  );
};

export default CodeOfConduct;
